export default __webpack_public_path__ + "static/article-5-tips-for-surviving-the-boxing-day-sales-2b92ea93ce49f4d122f48115425ddc12.jpg";